import GLightbox from "glightbox";
import Splide from "@splidejs/splide";
import {FloatLabels} from "@keodesign/float-labels";

export function init() {
	setupMapClick();
	GLightbox({
		touchNavigation: true,
		loop: true,
		autoplayVideos: true
	});
	setupTestimonialSlider();
	setupAutoHideMenu();
	new FloatLabels(".js-float-wrap");
}

export function setupAutoHideMenu(){
	let lastScrollTop = 0;
	const menu = document.querySelector("#header-wrap");

	window.addEventListener("scroll", () => {
		let scrollTop = window.scrollY || document.documentElement.scrollTop;
		if (scrollTop > 500){
			if (scrollTop > lastScrollTop) {
				// Scrolling down
				menu.style.top = "-120px"; // Hide menu
			} else {
				// Scrolling up
				menu.style.top = "0";
			}
			lastScrollTop = scrollTop;
		}
		
	});
}

export function setupMapClick(){
	const map_click_list = document.querySelectorAll("#map-click, .map-click");
	if (map_click_list) {
		map_click_list.forEach((map_click) => {
			map_click.addEventListener("click", () => {
				// shield the map on mobile for easy scrolling
				map_click.style.display = "none";
			});
		});
	}
}


export function setupTestimonialSlider(){
	var testimonialSlider = document.querySelectorAll(".testimonial-slider");
	
	if(testimonialSlider){
		for (var i = 0; i < testimonialSlider.length; i++ ) {
			var slider = testimonialSlider[i].querySelector(".slider");
			
			new Splide( slider, {
				type   : "slide",
				rewind    : true,
				pagination: true,
				arrows    : false,
				autoplay: true,
			}).mount();
		}
	}
}


window.addEventListener("DOMContentLoaded", init);